// @flow

import React, { type Node, useCallback, useRef } from 'react';
import { InputText } from '../../atom/input-text';
import { useInputMask } from '@tectonics/components/input-mask/use-input-mask';
import cvvImageSrc from './cvv.svg';

export function InputCardCvv(props: InputCardCvvProps): Node {
  const { style, placeholder, value, onChange, ...rest } = props;

  const inputRef = useRef();
  const updateValueForMask = useInputMask(inputRef, MASK, value);

  const handleChange = useCallback((event: SyntheticInputEvent<InputText>) => {
    updateValueForMask();
    if (onChange) {
      onChange(event);
    }
  }, [onChange, updateValueForMask]);

  return (
    <div style={{ position: 'relative' }}>
      <InputText
        {...rest}
        type="tel"
        ref={inputRef}
        style={style}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
      />
      <img src={cvvImageSrc} alt="CVV" style={{
        position: 'absolute',
        height: '20px',
        top: '50%',
        marginTop: '-10px',
        right: '0.5em',
        pointerEvents: 'none',
      }} />
    </div>
  );
}

type InputCardCvvProps = {
  style?: { [string]: string },
  placeholder?: string,
  value?: string,
  onChange?: (evt: SyntheticInputEvent<InputText>) => void,
};

const MASK = [
  /\d/, /\d/, /\d/, /\d/,
];
